export function currency (amountInCents, currency, fractionDigits = 0, locale) {
    locale = locale ? locale : window.vue.$data._locale
    currency = currency ? currency : window.vue.$data._currency

    return new Intl.NumberFormat(locale,
        {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: fractionDigits,
        })
        .format(amountInCents / 100)
}
